import { OptionGroup } from 'react-querybuilder';

import { ApiBase } from './API';
import { apiUrls } from 'constants/apiUrls';
import { AlarmDefinition, AlarmRulesCount, AlarmMetadata } from 'types/types';

export interface IAlarmModuleService {
  GetAlarmDefinition: (
    skip: number,
    take: number,
    activeStatus: string
  ) => Promise<AlarmDefinition[]>;
  GetAlarmRulesCount: () => Promise<AlarmRulesCount>;
  GetAlarmMetadata: () => Promise<AlarmMetadata>;
  GetAlarmQueryOperators: () => Promise<OptionGroup[]>;
  GetAlarmDefinitionById: (alarmId: number) => Promise<AlarmDefinition>;
  CreateAlarmDefinition: (
    alarmDefinition: AlarmDefinition,
    duplicate: boolean
  ) => Promise<string>;
  EditAlarmDefinition: (alarmDefinition: AlarmDefinition) => Promise<string>;
  DeleteAlarmDefinition: (alarmId: number) => Promise<string>;
  ChangeAlarmStatus: (alarmId: number, alarmStatus: boolean) => Promise<string>;
  GetDuplicateAlarmDefinition: (
    alarmIdToCopy: number
  ) => Promise<AlarmDefinition>;
}
//const alarmDefinitionUrl = 'https://localhost:63164';
// const alarmDefinitionUrl =
//   process.env.REACT_APP_NI_ALARM_MANAGEMENT_API_URL ?? '';

class AlarmModuleService extends ApiBase implements IAlarmModuleService {
  constructor() {
    super('');
  }

  public GetAlarmDefinition = async (
    skip: number,
    take: number,
    activeStatus: string
  ): Promise<AlarmDefinition[]> => {
    return this.instance.get<AlarmDefinition[]>(
      `${apiUrls.alarmDefinitionUrl}?skip=${skip}&take=${take}&activeStatus=${activeStatus}`
    );
  };

  public GetAlarmRulesCount = async (): Promise<AlarmRulesCount> => {
    return this.instance.get<AlarmRulesCount>(apiUrls.alarmRulesCountUrl);
  };

  public GetAlarmMetadata = async (): Promise<AlarmMetadata> => {
    return this.instance.get<AlarmMetadata>(apiUrls.alarmMetadata);
  };

  public CreateAlarmDefinition = async (
    alarmDefinition: AlarmDefinition,
    duplicate: boolean
  ) => {
    return this.instance.post<string>(
      `${apiUrls.createAlarmDefinition}?duplicate=${duplicate}`,
      alarmDefinition
    );
  };

  public GetAlarmQueryOperators = async () => {
    return this.instance.get<OptionGroup[]>(apiUrls.alarmQueryOperatorsUrl);
  };

  public EditAlarmDefinition = async (alarmDefinition: AlarmDefinition) => {
    return this.instance.put<string>(
      apiUrls.editAlarmDefinition,
      alarmDefinition
    );
  };

  public GetAlarmDefinitionById = async (
    alarmId: number
  ): Promise<AlarmDefinition> => {
    return this.instance.get<AlarmDefinition>(
      `${apiUrls.alarmDefinitionByIdUrl}?alarmId=${alarmId}`
    );
  };

  public GetDuplicateAlarmDefinition = async (
    alarmIdToCopy: number
  ): Promise<AlarmDefinition> => {
    return this.instance.get<AlarmDefinition>(
      `${apiUrls.duplicateAlarmDefinitionUrl}?alarmId=${alarmIdToCopy}`
    );
  };
  public DeleteAlarmDefinition = async (alarmId: number): Promise<string> => {
    return this.instance.delete<string>(
      `${apiUrls.deleteAlarmDefinition}?alarmId=${alarmId}`
    );
  };
  public ChangeAlarmStatus = async (
    alarmId: number,
    alarmStatus: boolean
  ): Promise<string> => {
    return this.instance.put<string>(
      `${apiUrls.changeAlarmStatusUrl}?alarmId=${alarmId}&alarmStatus=${alarmStatus}`
    );
  };
}

export default AlarmModuleService;
